// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2uQnh","containerItemsCenter":"Skeleton_containerItemsCenter__3tjUX"};